
export default function Header(){
    return <div>
        <h1 className="header">Daily Meal Plan Generator</h1>
        <p className="paragraph">Welcome to the daily meal plan generator. To get started, insert your targeted calories for the day in the input box below and click "Get Daily Meal Plan". This will generate three meal ideas for you to reach your goal. </p>
        </div>
    }